import React, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
// import { Link as RouterLink, useLocation, useHistory } from 'react-router-dom';
import { useLocation, useHistory } from 'react-router-dom';
// import { LinkExternal as RouterLink } from "./../LinkExternal";
import LinkExternal from "./../LinkExternal";

export const ensureSearch = (Component) => ({ to, onClick, ...rest }) => {
  const location = useLocation();
  const history = useHistory();
  const href = useMemo(
    () => (typeof to === 'string'
      ? {
        pathname: to,
        search: location.search,
      } : {
        ...to,
        search: [
          '?',
          [
            location.search.substr(1).split('&'),
            (typeof to.search === 'string' ? to.search : '?').substr(1).split('&'),
          ]
            .flat()
            .filter(Boolean)
            .join('&'),
        ].join(''),
      }),
    [to, location],
  );
  const interactionOverride = useCallback(
    (e) => {
      e.preventDefault();
      // console.log(onClick);
      if (onClick) {
        onClick(e, href);
      }
      history.push(href);
    },
    [history, href],
  );
  return <Component onClick={interactionOverride} to={href} {...rest} />;
};

export const Link = styled(LinkExternal)`
  &, &:visited, &:link {
    color: inherit;
    color: initial;
    text-decoration: none;
  }
`;

export default Link;
